.stepper {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.5rem 1rem;
}

.hint {
  flex-basis: 100%;
  margin: 0;
  color: var(--text-muted);
}
